import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const ErrorPage = ({ refetch }) => {
  return (
    <Container className="text-center mt-5">
      <Row>
        <Col>
          <h1 className="display-4">Oops!</h1>
          <p className="lead">Something went wrong. Please refresh the page.</p>
          <Button variant="primary" onClick={refetch}>
            Refetch
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorPage;
